import React from "react";
import { AiOutlineFieldTime } from "react-icons/ai";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import UseTitle from "../../Hooks/UseTitle";
import restaurant from "../../../Assets/Hompage/Restaurant/Restaurant (7).jpeg";
import restaurantCoverMobile from "../../../Assets/restaurant_mobile-05.jpg";
import restaurant1 from "../../../Assets/Hompage/Restaurant/Restaurant (4).jpeg";
import restaurant2 from "../../../Assets/Hompage/Restaurant/Restaurant (5).jpeg";
import restaurant3 from "../../../Assets/Hompage/Restaurant/Restaurant (3).jpeg";
import restaurant4 from "../../../Assets/Hompage/Restaurant/Restaurant (1).jpeg";
import restaurant5 from "../../../Assets/Hompage/Restaurant/Restaurant (2).jpeg";
import restaurant6 from "../../../Assets/Hompage/Restaurant/Restaurant (6).jpeg";

const Restaurentssingle = () => {
  UseTitle("Restaurant");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="bg-gray-100">
      <div className="pt-16 md:pt-0 md:block hidden">
        <img src={restaurant} alt="Restaurant" className="w-full" />
      </div>
      <div className="pt-16 md:pt-0 block md:hidden">
        <img src={restaurantCoverMobile} alt="Restaurant" className="w-full" />
      </div>
      <div className="max-w-screen-xl mx-auto md:py-20">
        <div className="py-10 md:px-16 px-5 bg-white">
          <div className="nahid-title-designer flex justify-center md:justify-start py-5">
            <h1 className="md:text-[40px] text-[25px] font-bold tracking-wide md:text-start">
              Restaurant
            </h1>
          </div>
          <div className="flex justify-center md:justify-start ">
            {" "}
            <p className="flex md:text-[20px] gap-5  items-center text-[20px] py-5 font-bold">
              <span>
                <AiOutlineFieldTime className="text-[#bb4f32] text-[20px]" />
              </span>
              <span>Time Schedule</span>
            </p>
          </div>
          <div className="pt-8  gap-6 items-center grid grid-cols-1 md:grid-cols-3 ">
            <div>
              <p className="text-[20px] text-center md:text-start">
                <span className="italic">Breakfast : 7:30 AM - 10:30 AM</span>
              </p>
            </div>
            <div>
              {" "}
              <p className="text-[20px] text-center md:text-start">
                <span className="italic">Lunch : 12:00 PM - 04:00 PM</span>
              </p>
            </div>
            <div>
              <p className="text-[20px] text-center md:text-start">
                <span className="italic">Dinner : 7:00 PM - 10:30 PM</span>
              </p>
            </div>
          </div>
          <div className="py-20">
            <p className="text-[16px] md:text-start text-justify">
              We have large exotic food outlets to provide top level services to
              our clients. Our multi cuisine restaurant offers a wide range of
              Bengali, Indian, Thai, Chinese and Continental dishes. Our menus
              are bursting with unique and savory experiences that change with
              seasons. In one sitting we can provide services to 100 people.
            </p>
          </div>
        </div>

        <div className="md:px-0 px-5">
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlaySpeed={2000}
            autoPlay={true}
            customTransition="all .5"
          >
            <div>
              <img
                src={restaurant1}
                alt="Restaurant cover"
                className="w-full"
              />
            </div>
            <div>
              <img src={restaurant2} alt="Restaurant" className="w-full" />
            </div>
            <div>
              <img src={restaurant3} alt="Restaurant" className="w-full" />
            </div>
            <div>
              <img src={restaurant4} alt="Restaurant" className="w-full" />
            </div>
            <div>
              <img src={restaurant5} alt="Restaurant" className="w-full" />
            </div>

            <div>
              <img src={restaurant6} alt="Restaurant" className="w-full" />
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Restaurentssingle;
